import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    PayrollExportId,
    PayrollExportNumberOfTimesheets
} from 'services/payrollExports/types';
import { makeSelectNumberOfTimesheets } from 'services/payrollExports/selectors';

export interface OwnProps {
    id: PayrollExportId;
}

interface ConnectedProps {
    numberOfTimesheets: ReturnType<
        ReturnType<typeof makeSelectNumberOfTimesheets>
    >;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetSubmissionsNumberOfTimesheetsComponent extends React.PureComponent<Props> {
    render(): PayrollExportNumberOfTimesheets | null {
        const { numberOfTimesheets } = this.props;

        if (!numberOfTimesheets) {
            return null;
        }

        return numberOfTimesheets;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    numberOfTimesheets: makeSelectNumberOfTimesheets()
});

export default connect(mapStateToProps)(
    TimesheetSubmissionsNumberOfTimesheetsComponent
);
